import type { PickerListItem } from "@/features/sparxsEditor/components/molecules/pickerList/pickerList";
import { getItemsForKeyDown } from "./stepProps";
import type { DirectiveBuilderState } from "./printTable";
import type { Variables } from "@/lib/sparxs/metadataSchemas";

export type MutableDirectiveBuilderListKeyDownState = {
  builder: DirectiveBuilderState;
  listFilterText: string;
  currentProps: {
    items: PickerListItem[];
    command: (item: PickerListItem) => void;
    clientRect: (() => DOMRect | null) | null;
  } | null;
  currentOnSelectItem: ((item: PickerListItem) => void) | null;
  update: () => void;
};

export const handleDirectiveBuilderListKeyDown = (
  mutableState: MutableDirectiveBuilderListKeyDownState,
  variables: Variables[],
  event: KeyboardEvent,
): boolean => {
  const props = mutableState.currentProps;
  const b = mutableState.builder;
  if (props == null) return false;
  if (b.step === "choice") return false;
  const items = getItemsForKeyDown(
    b,
    variables,
    props,
    mutableState.listFilterText,
  );
  if (items.length === 0) return false;
  if (event.key === "ArrowDown") {
    mutableState.builder = {
      ...b,
      selectedIndex: Math.min(b.selectedIndex + 1, items.length - 1),
    };
    mutableState.update();
    return true;
  }
  if (event.key === "ArrowUp") {
    mutableState.builder = {
      ...b,
      selectedIndex: Math.max(b.selectedIndex - 1, 0),
    };
    mutableState.update();
    return true;
  }
  if (event.key === "Enter") {
    const item = items[b.selectedIndex];
    if (item != null && mutableState.currentOnSelectItem != null) {
      mutableState.currentOnSelectItem(item);
    }
    return true;
  }
  return false;
};
